import React, { useState, useEffect } from 'react';
import { developmentConfig } from '../../config/authConfig';
import LoadingSpinner from '../common/LoadingSpinner';
import '../../styles/LoginPage.css';

interface LoginPageProps {
  onLogin: () => void;
  authError?: string | null;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin, authError }) => {
  const isDevelopment = developmentConfig.enabled;
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(authError || null);
  
  // Check session storage for auth errors on component mount or when authError prop changes
  useEffect(() => {
    const storedError = sessionStorage.getItem('authErrorMessage');
    if (storedError) {
      setErrorMessage(storedError);
      // Clear the error after retrieving it
      sessionStorage.removeItem('authErrorMessage');
    } else if (authError) {
      setErrorMessage(authError);
    }
  }, [authError]);

  const handleLoginClick = () => {
    setIsLoading(true);
    onLogin();
    if (isDevelopment) {
      setTimeout(() => setIsLoading(false), 500);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <img src="/images/logo.png" alt="Primas Accounting Logo" className="login-logo" />
            <h1>Primas Accounting</h1>
            <p>Expense Management Application</p>
            {isDevelopment && (
              <div className="dev-notice">
                <small>Development Mode</small>
              </div>
            )}
          </div>
          <div className="login-body">
            {isLoading ? (
              <div className="login-loading">
                <LoadingSpinner size="medium" message="Signing you in..." />
              </div>
            ) : (
              <>
                <p className="login-description">
                  {isDevelopment
                    ? "Click the button below to continue in development mode."
                    : "Sign in with your Microsoft 365 account to access the expense management system."}
                </p>
                {errorMessage && (
                  <div className="login-error">
                    <p>{errorMessage}</p>
                  </div>
                )}
                <button onClick={handleLoginClick} className="btn-login login-button">
                  <i className={isDevelopment ? "fas fa-code" : "fab fa-microsoft"}></i>
                  {isDevelopment ? "Continue in Dev Mode" : "Sign in with Microsoft 365"}
                </button>
                {!isDevelopment && (
                  <p className="login-hint">
                    <small>You'll be redirected to Microsoft to authenticate.</small>
                  </p>
                )}
              </>
            )}
          </div>
          <div className="login-footer">
            <p>© {new Date().getFullYear()} Primas Accounting - All rights reserved.</p>
          </div>
        </div>
      </div>
      {/* Styles are now in LoginPage.css */}
    </div>
  );
};

export default LoginPage;
